(() => {
  const initReplenishment = (root = document) => {
    root.querySelectorAll('[data-av42-replenishment]').forEach((fieldset) => {
      if (fieldset.dataset.av42Ready === 'true') return;
      fieldset.dataset.av42Ready = 'true';
      fieldset.addEventListener('change', (event) => {
        if (!event.target.matches('[data-av42-selling-plan]')) return;
        fieldset.querySelectorAll('[data-av42-purchase-choice]').forEach((choice) => {
          choice.classList.toggle('is-selected', choice.contains(event.target));
        });
      });
    });
  };

  const normalize = (value) => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  const initLocators = (root = document) => {
    root.querySelectorAll('[data-av42-locator]').forEach((locator) => {
      if (locator.dataset.av42Ready === 'true') return;
      locator.dataset.av42Ready = 'true';
      const input = locator.querySelector('[data-av42-locator-input]');
      const form = locator.querySelector('[data-av42-locator-form]');
      const stores = [...locator.querySelectorAll('[data-av42-store]')];
      const empty = locator.querySelector('[data-av42-locator-empty]');
      const status = locator.querySelector('[data-av42-locator-status]');
      const filters = [...locator.querySelectorAll('[data-au-locator-filter]')];
      const loadMore = locator.querySelector('[data-au-locator-load-more]');
      const initialVisible = Number.parseInt(locator.dataset.initialVisible || '12', 10);
      let visibleLimit = Number.isFinite(initialVisible) ? initialVisible : 12;
      let selectedCategory = 'all';

      const analytics = (event, payload) => window.AVAnalytics?.custom?.(event, payload, { ttl: 300 });
      const queryType = (value) => {
        const compact = String(value || '').replace(/\D/g, '');
        return compact.length >= 3 && /^\s*[\d.\-\s]+\s*$/.test(String(value || '')) ? 'postcode' : 'city_or_partner';
      };
      const categoryMatches = (store) => {
        const category = store.dataset.auLocationType || 'outro';
        if (selectedCategory === 'all') return true;
        if (selectedCategory === 'outro') return !['supermercado', 'loja_natural', 'cafe'].includes(category);
        return category === selectedCategory;
      };
      const announce = (count) => {
        if (!status) return;
        const label = count === 1 ? locator.dataset.statusSingular : locator.dataset.statusPlural;
        status.textContent = label ? `${count} ${label}` : String(count);
      };
      const apply = ({ trackSearch = false, announceResults = false } = {}) => {
        const term = normalize(input?.value || '');
        const matches = stores.filter((store) => categoryMatches(store) && (!term || normalize(store.dataset.av42Search || '').includes(term)));
        stores.forEach((store) => {
          const matchIndex = matches.indexOf(store);
          const matchesQuery = matchIndex !== -1;
          store.hidden = !matchesQuery;
          store.classList.toggle('is-page-hidden', matchesQuery && matchIndex >= visibleLimit);
        });
        if (empty) empty.hidden = matches.length !== 0;
        if (loadMore) loadMore.hidden = matches.length <= visibleLimit;
        if (announceResults) announce(matches.length);
        if (trackSearch) {
          analytics('australia:store_locator_search', {
            query_type: queryType(input?.value),
            result_count: matches.length,
            source: 'store_locator'
          });
        }
        return matches.length;
      };

      if (input && form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          visibleLimit = initialVisible;
          apply({ trackSearch: true, announceResults: true });
        });
      }

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          const nextCategory = button.dataset.auLocatorFilter || 'all';
          selectedCategory = selectedCategory === nextCategory ? 'all' : nextCategory;
          visibleLimit = initialVisible;
          filters.forEach((item) => item.setAttribute('aria-pressed', String(item === button && selectedCategory !== 'all')));
          const resultCount = apply({ announceResults: true });
          analytics('australia:store_locator_filter', {
            selected_category: selectedCategory,
            result_count: resultCount,
            source: 'store_locator'
          });
        });
      });

      loadMore?.addEventListener('click', () => {
        const visibleBefore = visibleLimit;
        visibleLimit += initialVisible;
        const resultCount = apply({ announceResults: true });
        analytics('australia:store_locator_load_more', {
          visible_before: visibleBefore,
          visible_after: Math.min(visibleLimit, resultCount),
          source: 'store_locator'
        });
      });

      locator.querySelectorAll('[data-au-partner-link]').forEach((link) => {
        link.addEventListener('click', () => {
          const payload = {
            partner_id: link.dataset.auPartnerId,
            partner_name: link.dataset.auPartnerName,
            partner_type: link.dataset.auPartnerType,
            placement: link.dataset.auPlacement,
            source: 'store_locator'
          };
          analytics('australia:store_locator_partner', payload);
          analytics('australia:store_locator_outbound', payload);
        });
      });

      locator.querySelectorAll('[data-au-location-link]').forEach((link) => {
        link.addEventListener('click', () => analytics('australia:store_locator_outbound', {
          location_id: link.dataset.auLocationId,
          placement: 'location',
          source: 'store_locator'
        }));
      });

      locator.querySelector('[data-au-first-party-link]')?.addEventListener('click', () => analytics('australia:store_locator_outbound', {
        partner_name: 'AUSTRALIA',
        partner_type: 'first_party',
        placement: 'online',
        source: 'store_locator'
      }));

      if (stores.length) apply();
    });
  };

  const initLocatorReviewSafeAreas = (root = document) => {
    root.querySelectorAll('[data-au-locator-review-safe-area]').forEach((safeArea) => {
      if (safeArea.dataset.auReviewSafeAreaReady === 'true') return;
      safeArea.dataset.auReviewSafeAreaReady = 'true';

      const placeNotification = () => {
        document.querySelectorAll('.loox-pn, #smile-ui-lite-launcher-frame-container, .smile-launcher-frame-container').forEach((floatingElement) => {
          if (!safeArea.contains(floatingElement)) safeArea.appendChild(floatingElement);
        });
      };

      placeNotification();
      const observer = new MutationObserver(placeNotification);
      observer.observe(document.body, { childList: true, subtree: true });
    });
  };

  const init = (root = document) => {
    initReplenishment(root);
    initLocators(root);
    initLocatorReviewSafeAreas(root);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
